import React from "react";

export default ({ largeColor, border }) => (
  <svg
    width="100%"
    // height="950"
    viewBox="0 0 950 950"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_b)">
      <circle cx="475" cy="475" r="200" fill="white" fill-opacity="0.2" />
      <circle
        cx="475"
        cy="475"
        r="199.5"
        stroke={border ? border : "#FAAA31"}
      />
    </g>
    <g filter="url(#filter1_f)">
      <circle
        cx="475"
        cy="475"
        r="225"
        fill={largeColor ? largeColor : "#ee8437"}
        fill-opacity="0.5"
      />
    </g>
    <path
      d="M400.059 554.388C402.544 558.044 405.088 561.084 403.167 562.869C401.736 564.199 399.753 563.726 396.778 560.525C394.049 557.587 393.932 554.818 395.476 553.383L390.367 547.885C386.224 551.734 385.185 557.262 392.114 564.719C398.413 571.498 403.959 572.029 408.591 567.724C413.223 563.42 411.729 559.546 408.299 553.89C404.632 547.754 402.314 545.486 404.197 543.736C405.741 542.302 407.961 543.256 410.691 546.194C413.141 548.83 414.837 552.166 412.314 554.511L417.598 560.198C422.569 555.578 422.602 549.723 415.673 542.266C409.199 535.299 403.37 533.557 397.872 538.666C392.11 544.02 396.406 548.87 400.059 554.388Z"
      fill="#051C4C"
    />
    <path
      d="M382.441 526.933L380.084 521.679L375.487 523.742L377.844 528.995L372.169 531.541L374.883 537.592L380.559 535.046L382.032 538.329L386.629 536.267L385.155 532.983L393.739 529.132C399.18 526.691 402.073 524.097 399.106 517.484C398.475 516.076 397.96 515.18 397.157 514.019L391.622 516.502C394.021 520.216 393.979 521.756 391.024 523.082L382.441 526.933Z"
      fill="#051C4C"
    />
    <path
      d="M369.47 510.711C369.037 508.753 367.521 507.614 365.363 508.092C363.254 508.559 362.311 510.242 362.744 512.2C363.178 514.157 364.732 515.235 366.841 514.768C368.999 514.29 369.904 512.668 369.47 510.711ZM395.68 508.278L394.258 501.853L371.068 506.987L372.49 513.412L395.68 508.278Z"
      fill="#051C4C"
    />
    <path
      d="M368.784 480.759C368.656 483.687 370.039 486.166 372.328 487.964L369.144 487.825L368.856 494.399L400.032 495.762L400.319 489.188L389.688 488.723C392.124 487.132 393.719 484.783 393.847 481.855C394.097 476.154 389.833 471.285 381.769 470.933C373.706 470.58 369.033 475.058 368.784 480.759ZM388.276 483.361C388.1 487.367 384.831 489.18 380.979 489.011C377.075 488.841 374.028 486.752 374.203 482.746C374.378 478.74 377.59 477.079 381.493 477.25C385.345 477.418 388.451 479.355 388.276 483.361Z"
      fill="#051C4C"
    />
    <path
      d="M387.728 457.37L394.256 441.656C385.025 437.209 378.908 441.348 376.719 446.617C374.549 451.84 375.478 458.85 383.786 462.302C392.047 465.733 397.717 461.464 399.887 456.242C401.78 451.684 401.45 446.314 396.037 442.729L393.788 448.142C395.229 449.631 395.892 451.521 394.787 454.179C393.505 457.265 390.726 458.059 387.728 457.37ZM381.779 448.775C382.923 446.022 385.101 445.201 387.616 445.578L383.553 455.358C381.551 453.746 380.655 451.481 381.779 448.775Z"
      fill="#051C4C"
    />
    <path
      d="M402.606 430.202L413.982 417.547C406.752 410.287 399.607 412.16 395.792 416.404C392.012 420.609 390.56 427.53 397.251 433.545C403.903 439.525 410.669 437.381 414.45 433.176C417.749 429.505 419.221 424.331 415.305 419.151L411.387 423.51C412.252 425.393 412.249 427.395 410.324 429.536C408.09 432.021 405.205 431.847 402.606 430.202ZM399.849 420.119C401.842 417.902 404.169 417.851 406.417 419.042L399.337 426.918C397.983 424.733 397.89 422.298 399.849 420.119Z"
      fill="#051C4C"
    />
    <path
      d="M461.386 399.827L445.091 404.731L443.209 398.479L458.175 393.975L456.338 387.87L441.372 392.374L439.742 386.959L455.742 382.144L453.919 376.089L430.93 383.008L439.923 412.89L463.208 405.882L461.386 399.827Z"
      fill="#051C4C"
    />
    <path
      d="M484.308 381.662C480.204 381.394 477.67 383.907 476.81 385.241L477.031 381.856L470.465 381.426L468.913 405.126L475.479 405.556L476.39 391.654C476.561 389.038 478.231 387.138 481.155 387.329C484.131 387.524 485.333 389.612 485.162 392.228L484.252 406.131L490.869 406.564L491.897 390.866C492.247 385.531 489.336 381.992 484.308 381.662Z"
      fill="#051C4C"
    />
    <path
      d="M511.661 394.021L517.047 396.058L518.829 391.346L513.444 389.309L515.644 383.491L509.441 381.145L507.241 386.963L503.875 385.69L502.092 390.402L505.458 391.675L502.13 400.475C500.021 406.053 499.817 409.933 506.597 412.497C508.04 413.043 509.038 413.311 510.427 413.561L512.573 407.887C508.249 406.966 507.188 405.85 508.333 402.821L511.661 394.021Z"
      fill="#051C4C"
    />
    <path
      d="M525.963 411.018L539.469 421.369C546.141 413.593 543.715 406.617 539.186 403.145C534.697 399.705 527.684 398.799 522.211 405.94C516.77 413.04 519.436 419.618 523.925 423.058C527.842 426.06 533.116 427.122 537.973 422.813L533.322 419.248C531.512 420.258 529.515 420.412 527.23 418.66C524.578 416.628 524.526 413.738 525.963 411.018ZM535.799 407.48C538.166 409.294 538.398 411.61 537.387 413.944L528.981 407.502C531.054 405.981 533.473 405.698 535.799 407.48Z"
      fill="#051C4C"
    />
    <path
      d="M563.923 429.776C561.488 426.398 558.403 427.481 556.618 427.817L559.954 425.412L556.106 420.074L536.838 433.962L540.686 439.3L549.569 432.897C552.572 430.733 555.225 429.138 557.69 432.558C558.682 433.934 559.106 435.402 559.224 436.268L559.464 436.602L565.303 432.393C565.151 431.743 564.674 430.818 563.923 429.776Z"
      fill="#051C4C"
    />
    <path
      d="M575.921 455.719C574.997 452.938 572.821 451.115 570.042 450.25L573.067 449.246L570.993 443.001L541.378 452.836L543.452 459.081L553.551 455.727C551.842 458.082 551.188 460.845 552.112 463.626C553.91 469.042 559.63 472.072 567.289 469.528C574.949 466.984 577.719 461.135 575.921 455.719ZM556.781 460.234C555.517 456.428 557.927 453.57 561.586 452.354C565.294 451.123 568.886 451.989 570.15 455.794C571.413 459.6 569.004 462.296 565.296 463.527C561.637 464.742 558.045 464.039 556.781 460.234Z"
      fill="#051C4C"
    />
    <path
      d="M580.797 491.053C580.727 486.889 577.576 486.016 575.918 485.273L580.03 485.204L579.92 478.624L556.172 479.023L556.282 485.602L567.231 485.419C570.932 485.357 574.02 485.562 574.091 489.777C574.119 491.473 573.63 492.921 573.231 493.699L573.238 494.11L580.434 493.989C580.681 493.368 580.818 492.338 580.797 491.053Z"
      fill="#051C4C"
    />
    <path
      d="M580.554 507.261C580.181 509.231 581.126 510.875 583.298 511.286C585.419 511.688 586.95 510.513 587.323 508.543C587.696 506.573 586.691 504.97 584.57 504.568C582.398 504.157 580.927 505.291 580.554 507.261ZM555.506 499.171L554.282 505.636L577.619 510.054L578.843 503.589L555.506 499.171Z"
      fill="#051C4C"
    />
    <path
      d="M561.17 529.627C563.061 526.825 564.637 524.328 566.171 525.052C567.519 525.689 567.761 527.224 566.51 529.874C565.26 532.524 563.3 533.304 561.858 532.624L558.984 538.714C562.982 540.602 567.436 539.236 570.859 531.983C573.931 525.474 572.77 520.947 568.353 518.863C563.937 516.778 561.444 519.41 558.479 523.525C555.913 527.033 554.463 529.986 552.51 529.065C550.976 528.341 551.032 526.775 552.305 524.079C553.512 521.522 555.172 519.691 557.59 520.832L560.598 514.577C555.624 512.229 551.375 514.487 548.017 521.601C544.858 528.295 545.156 533.325 550.363 535.782C555.849 538.372 558.322 533.854 561.17 529.627Z"
      fill="#051C4C"
    />
    <path
      d="M543.7 548.04L531.693 560.097C538.543 567.717 545.773 566.211 549.8 562.168C553.791 558.161 555.594 551.323 549.219 544.975C542.881 538.663 536.014 540.458 532.024 544.465C528.541 547.962 526.807 553.055 530.453 558.428L534.589 554.275C533.821 552.35 533.926 550.35 535.958 548.31C538.316 545.943 541.188 546.264 543.7 548.04ZM545.939 558.25C543.835 560.363 541.508 560.295 539.324 558.991L546.797 551.487C548.038 553.738 548.006 556.174 545.939 558.25Z"
      fill="#051C4C"
    />
    <defs>
      <filter
        id="filter0_b"
        x="265"
        y="265"
        width="420"
        height="420"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation="5" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_f"
        x="0"
        y="0"
        width="950"
        height="950"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur stdDeviation="125" result="effect1_foregroundBlur" />
      </filter>
    </defs>
  </svg>
);
